import React from 'react'
import type { HTMLElementProps, Product } from '~/types'
import { cn, getPrice } from '~/utils'

type PromoProduct = Pick<Product, 'offer' | 'priceRange' | 'compareAtPriceRange'>

type Props = HTMLElementProps<'aside'> & {
	promo: PromoProduct | string
}

function getPromoText(product: PromoProduct) {
	const text = product.offer?.value || ''
	const discount =
		getPrice(product.compareAtPriceRange.minVariantPrice) - getPrice(product.priceRange.minVariantPrice)
	return text.replace('{DISCOUNT}', getPrice(discount, true, 0))
}

export const Promo: React.FC<Props> = ({ promo, className, ...props }) => {
	const promoText = typeof promo === 'string' ? promo : getPromoText(promo)
	return promoText ? (
		<aside className={cn('z-10 font-semibold leading-none', className)} {...props}>
			{promoText}
		</aside>
	) : null
}
